<template>
  <car-finance-list :vendor="'0'"></car-finance-list>
</template>

<script>
import CarFinanceList from '@/components/CarFinanceList';

export default {
  name: 'LoanhfcCarFinanceList',
  components: { CarFinanceList }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/LoanhfcCarFinanceList.vue